import { jsx } from "react/jsx-runtime";
import { Icon } from "../../../foundations/icons/Icon.js";
const getFeedbackIcon = (variant) => {
  switch (variant) {
    case "success":
      return /* @__PURE__ */ jsx(Icon, { variant: "Check2", "aria-hidden": "true" });
    case "error":
      return /* @__PURE__ */ jsx(Icon, { variant: "Error", "aria-hidden": "true" });
    case "info":
      return /* @__PURE__ */ jsx(Icon, { variant: "Info", "aria-hidden": "true" });
    case "warning":
      return /* @__PURE__ */ jsx(Icon, { variant: "Warning", "aria-hidden": "true" });
    default:
      console.error("Invalid variant");
      return null;
  }
};
export {
  getFeedbackIcon
};
